import { axios } from '@/lib/axios';
import { type SupportedLanguage } from '@/lib/i18n/config';

import { AuthUser } from '../types';

export type LoginCredentials = {
  email: string;
  password: string;
  language?: SupportedLanguage;
};

export const loginWithEmailAndPassword = (
  data: LoginCredentials
): Promise<AuthUser> => {
  return axios.post('/api/v1/auth/sign_in', data);
};
